/* Use z-indexes on the apps/rappider/src/styles/global/_variables.scss */
/*
  Copy of the css vars:
  $zindex-default: 990 !default;
  $zindex-dropdown-backdrop: 990 !default;
  $zindex-navbar: 1000 !default;
  $zindex-dropdown: 1000 !default;
  $zindex-fixed: 1030 !default;
  $zindex-sticky: 1030 !default;
  $zindex-modal-backdrop: 1040 !default;
  $zindex-modal: 1050 !default;
  $zindex-popover: 1060 !default;
  $zindex-tooltip: 1070 !default;
  $zindex-notification-container: 1090 !default;
*/
export const Z_INDEX_NOTIFICATION_CONTAINER = '1090';
